var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlucose = function SvgGlucose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glucose_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.94 47.67v2.86a5.32 5.32 0 0 0 4.36 5.247c1.863.377 3.791.275 5.604-.296a5.206 5.206 0 0 0 3.422-5.864 9.3 9.3 0 0 1-.163-1.558 6.92 6.92 0 0 1 2.317-5.125c1.443-1.357 3.07-3.299 1.483-8.272"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M28 25.36v-1.263A4.097 4.097 0 0 1 32.097 20h9.997a4.097 4.097 0 0 1 4.098 4.097v1.293M33.534 43.346h6.81v3.476h-6.81zM53.53 26.24h1.032c.764 0 1.384.62 1.384 1.384v5.654c0 .764-.62 1.384-1.384 1.384H53.53c-.765 0-1.385-.62-1.385-1.384v-5.654c0-.764.62-1.384 1.385-1.384M54.046 26.24v-4.805"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M28 25.36h18.191v9.093c0 2.785-1.834 5.043-4.097 5.043h-.993c-2.277.412-2.183 3.85-2.183 3.85H34.8s.094-3.438-2.183-3.85h-.52c-2.263 0-4.097-2.258-4.097-5.043z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.647 33.749a2.556 2.556 0 1 1-5.103-.003s-.028-1.825 2.125-5.126c0 0 .404-.685.81-.045 2.153 3.3 2.168 5.174 2.168 5.174"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glucose_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35505",
    result: "shape"
  })))));
};
export default SvgGlucose;